import script from "./FaqBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqBox.vue?vue&type=script&setup=true&lang=js"

import "./FaqBox.vue?vue&type=style&index=0&id=c8efdf1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8efdf1a"]])

export default __exports__